import { useState } from "react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { fieldActionMessage } from "@/lib/appointment-field-actions";
import { changeWorkOrderNotes } from "@/services/appointment-change.service";

type Props = {
    id: string;
    current: string | null;
    open: boolean;
    onClose: () => void;
    onSaved: (newComment: string) => void;
};

export default function EditCommentModal({id, current, open, onClose, onSaved}: Props) {
    const [value, setValue] = useState(current ?? "");
    const [saving, setSaving] = useState(false);

    const save = async () => {
        try {
            setSaving(true);
            await changeWorkOrderNotes(id, value.trim());
            toast.success("Work order notes updated");
            onSaved(value.trim());
            onClose();
        } catch (error) {
            toast.error(fieldActionMessage(error, "Failed to update work order notes"));
        } finally {
            setSaving(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Edit Work Order Notes</DialogTitle>
                </DialogHeader>

                <Textarea
                    className="h-32"
                    value={value}
                    onChange={e => setValue(e.target.value)}
                />

                <DialogFooter>
                    <Button variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button disabled={saving} onClick={save}>
                        Save
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}